import React, { useEffect, useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Typography,
} from '@mui/material';
import '../../styles/UserStyles.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import {
  BOOKING_PASSENGER_DETAILS,
  BOOKINGS,
} from '../../component/common/Routes/AppRoutes';
import '../../styles/UserStyles.css';
import ControlledTextInputField from '../../component/ui/FormFields/ControlledTextInputField';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllAirportRequest } from '../../redux/Airports/actions/airportActions';
import { fetchAllServiceRequest } from '../../redux/Service/ServiceAction';
import CustomButton from '../../component/ui/FormFields/Button';
import {
  VENDOR_BOOKING_PASSENGER_DETAILS,
  VENDOR_BOOKINGS,
} from '../../component/common/Routes/VendorRoutes';
import {
  CUSTOMER_BOOKING_PASSENGER_DETAILS,
  CUSTOMER_BOOKINGS,
} from '../../component/common/Routes/CustomerRoutes';
import {
  fetchServiceTypeRequest,
  fetchTransitServiceTypeRequest,
  resetBookingDetails,
} from '../../redux/Bookings/BookingAction';
import { fetchCustomersRequest } from '../../redux/Customers/actions/customerActions';
import { StarSymbol } from '../../Style';
import { fetchCustomersByVendorRequest } from '../../redux/Vendors/actions/vendorActions';
const AirPortDetails = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const location = useLocation();
  const form1Value = location.state?.form1Value || {};
  const form2Value = location.state?.form2Value || {};
  const customerDetails = location.state?.customerDetails || {};
  const form3Value = location.state?.form3Value || {};
  const isIntantBooking = Object.keys(customerDetails).length > 0;
  const airport = useSelector(
    (state) => state.airport.airportsList?.data || {}
  );

  const {
    formState: { errors },
    control,
    reset,
    handleSubmit,
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      customer:
        form1Value?.customer ||
        customerDetails?.full_name ||
        customerDetails?.fullName ||
        form1Value?.customerDetails?.full_name ||
        '',
      airport: form1Value?.airport || '',
      arrival_plan: form1Value?.arrival_plan || '',
      departure_plan: form1Value?.departure_plan || '',
      arrival_departure_type: form1Value?.arrival_departure_type || '',
      service_type: form1Value?.service_type || '',
      transit_service: form1Value?.transit_service || [],
      arrival_city: form1Value?.arrival_city || '',
      departure_city: form1Value?.departure_city || '',
      departure_date: form1Value?.departure_date || 0,
      departure_time: form1Value?.departure_time || '',
      arrival_date: form1Value?.arrival_date || 0,
      arrival_time: form1Value?.arrival_time || '',
      arrival_airline: form1Value?.arrival_airline || '',
      departure_airline: form1Value?.departure_airline || '',
      arrival_flight_number: form1Value?.arrival_flight_number || '',
      departure_flight_number: form1Value?.departure_flight_number || '',
      transit_plan: form1Value?.transit_plan,
    },

    mode: 'onChange',
  });

  const formValue = watch();
  const airportType = airport.filter((value) => {
    if (value?.id == formValue?.airport?.value) {
      const airportTypes = value?.airport_type;
      return airportTypes;
    }
  });
  const airportCategory = airportType[0]?.airport_type;
  useEffect(() => {
    dispatch(fetchAllAirportRequest());
    dispatch(fetchAllServiceRequest());
    if (user?.user_type === 2) {
      dispatch(
        fetchCustomersByVendorRequest({
          pagination_required: false,
          pagesize: 100,
          pageNo: 1,
          vendor_id: user?.vendor_id,
        })
      );
    } else {
      dispatch(fetchCustomersRequest({ pagesize: 100, pageNo: 1 }));
    }
  }, []);

  const { customers: response = {} } = useSelector((state) =>
    user?.user_type === 2 ? state.vendors : state.customers
  );

  const customers = response?.data || [];

  const filteredAirports = airport.filter((airport) => {
    if (airport?.status === 1 && airport?.approoved_status === 1) {
      return {
        airport,
      };
    }
  });

  const activeCustomers = customers.filter((customer) => {
    if (customer?.status === 0) {
      return {
        customer,
      };
    }
  });

  const serviceTypeDetail = useSelector(
    (state) => state.booking?.serviceType?.data?.AiportServices
  );

  const transitServiceTypeDetail = useSelector(
    (state) => state.booking?.transitServiceType?.data?.AiportServices
  );

  const viewCustomerField =
    user?.role === 'Admin' || user?.role === 'Vendor' || user?.role === 'Staff';

  const airports = filteredAirports.map((airport) => {
    return { value: airport.id, label: airport.name };
  });

  const services = serviceTypeDetail?.map((service) => {
    return {
      value: service?.service_id,
      label: service?.Service?.services,
      // label: `${service?.Service?.services} - ${service?.Service?.type_of_service}`
    };
  });

  const transitServices = transitServiceTypeDetail?.map((service) => {
    return {
      value: service?.service_id,
      label: service?.Service?.services,
    };
    //label: `${service?.Service?.services} - ${service?.Service?.type_of_service}` };
  });
  const customerOptions = activeCustomers.map((customer) => ({
    value: customer.id,
    label: customer.display_name + ' - ' + customer.customer_serial_no,
  }));
  console.log('airportCategory', airportCategory);
  const typeOfAirport =
    airportCategory === 'International' || airportCategory === 'Both'
      ? [
          { value: 'Domestic', label: 'Domestic' },
          { value: 'International', label: 'International' },
          { value: 'Both', label: 'Both' },
        ]
      : [{ value: 'Domestic', label: 'Domestic' }];
  const tableContent =
    formValue?.arrival_departure_type?.value === 'Transit'
      ? transitServiceTypeDetail?.map((value) => ({
          service: value?.Service?.services || 'N/A',
          departure: value?.departure || 'N/A',
          arrival: value?.arrival || 'N/A',
          transit: value?.transit || 'N/A',
          type_of_service: value?.Service?.type_of_service || 'N/A',
          price: value?.price || 0,
        }))
      : serviceTypeDetail?.map((value) => ({
          service: value?.Service?.services || 'N/A',
          departure: value?.departure || 'N/A',
          arrival: value?.arrival || 'N/A',
          transit: value?.transit || 'N/A',
          type_of_service: value?.Service?.type_of_service || 'N/A',
          price: value?.price || 0,
        }));
  //this will give transit service Domestic to International this like
  const transitServiceType = serviceTypeDetail?.map((value) => {
    return {
      label: value?.Service?.transit_name,
      value: value?.Service?.transit_type,
    };
  });

  const service = formValue.arrival_departure_type?.value;

  useEffect(() => {
    dispatch(resetBookingDetails());
  }, []);

  useEffect(() => {
    if (formValue) {
      formValue?.arrival_departure_type?.value === 'Departure'
        ? reset({
            ...formValue,
            arrival_city: '',
            arrival_date: 0,
            arrival_time: '',
            arrival_airline: '',
            arrival_flight_number: '',
            arrival_plan: '',
            transit_plan: '',
          })
        : formValue?.arrival_departure_type?.value === 'Arrival'
        ? reset({
            ...formValue,
            departure_city: '',
            departure_date: 0,
            departure_time: '',
            departure_airline: '',
            departure_flight_number: '',
            transit_plan: '',
            departure_plan: '',
          })
        : reset({
            ...formValue,
          });
    }
  }, [service]);

  const taxs = airport?.filter((value) => {
    return value.id === formValue?.airport?.value;
  });

  const choosenService = serviceTypeDetail?.filter((value) => {
    return (
      value.service_id === formValue?.departure_plan?.value ||
      value.service_id === formValue?.arrival_plan?.value
    );
  });

  const choosenTransitService = serviceTypeDetail?.filter((value) => {
    return value.service_id === formValue?.transit_plan?.value;
  });

  const serviceType =
    airportCategory === 'International' || airportCategory === 'Both'
      ? [
          { value: 'Arrival', label: 'Arrival' },
          { value: 'Departure', label: 'Departure' },
          { value: 'Transit', label: 'Transit' },
        ]
      : [
          { value: 'Arrival', label: 'Arrival' },
          { value: 'Departure', label: 'Departure' },
          // { value: 'Transit', label: 'Transit' },
        ];

  const servicePlanPrice =
    choosenService != undefined ? choosenService[0]?.price : ' ';

  const transitServicePlanPrice =
    choosenTransitService != undefined ? choosenTransitService[0]?.price : ' ';

  const servicePrice =
    servicePlanPrice > 0 ? servicePlanPrice : transitServicePlanPrice;

  const sgstAmount = (servicePrice * taxs[0]?.sgst) / 100;
  const cgstAmount = (servicePrice * taxs[0]?.cgst) / 100;
  const taxAmount = (servicePrice * taxs[0]?.tax) / 100;
  const sgst = sgstAmount;
  const cgst = cgstAmount;
  const tax = taxAmount;

  const formValue11 = {
    ...formValue,
    departure_date: formValue.departure_date || null,
    customerDetails:
      Object.keys(customerDetails || {}).length > 0
        ? customerDetails
        : form1Value?.customerDetails,
    arrival_date: formValue.arrival_date || null,
    sgst: sgst,
    cgst: cgst,
    tax: tax,
    tax_percentage: taxs[0]?.tax,
    sgst_percentage: taxs[0]?.sgst,
    cgst_percentage: taxs[0]?.cgst,
    servicePlanPrice:
      servicePlanPrice !== undefined
        ? servicePlanPrice
        : transitServicePlanPrice,
  };

  const service_type =
    formValue.arrival_departure_type?.value === 'Arrival'
      ? 1
      : formValue.arrival_departure_type?.value === 'Departure'
      ? 2
      : 3;
  const airport_type =
    formValue.service_type?.value === 'Domestic'
      ? 1
      : formValue.service_type?.value === 'International'
      ? 2
      : 3;
  const airport_id = formValue.airport?.value;
  const transit_type = formValue.transit_service?.value;

  useEffect(() => {
    if (
      formValue.service_type &&
      formValue.arrival_departure_type?.value &&
      formValue.airport
    ) {
      dispatch(resetBookingDetails());
      dispatch(
        fetchServiceTypeRequest({ service_type, airport_type, airport_id })
      );
      setValue('transit_service', ' ');
    }
  }, [
    formValue.service_type,
    formValue.arrival_departure_type,
    formValue.airport,
  ]);

  useEffect(() => {
    if (formValue.transit_service?.value >= 0) {
      dispatch(
        fetchTransitServiceTypeRequest({
          transit_type,
          service_type,
          airport_id,
        })
      );
    }
  }, [formValue.transit_service, formValue.service_type]);
  const navigate = useNavigate();

  const fields = [
    ...(viewCustomerField
      ? [
          Object.keys(customerDetails || {}).length > 0 ||
          (form1Value &&
            Object.keys(form1Value.customerDetails || {}).length > 0)
            ? // customerDetails !== undefined
              {
                name: 'customer',
                label: 'Customer *',
                rules: { required: 'Customer is required' },
                placeholder: 'Select Customer',
                disabled: true,
                sm: 6,
              }
            : {
                name: 'customer',
                label: 'Customer *',
                rules: { required: 'Customer is required' },
                options: customerOptions,
                placeholder: 'Select Customer',
                sm: 6,
              },
        ]
      : []),
    {
      name: 'airport',
      label: 'Airport *',
      rules: { required: 'Airport is required' },
      options: airports,
      placeholder: 'Select Airport',
      sm: viewCustomerField ? 6 : 12,
    },
    {
      name: 'arrival_departure_type',
      label: 'Arrival/Departure',
      rules: { required: 'Arrival/Departure type is required' },
      options: serviceType,
      placeholder: 'Select Arrival/Departure Type',
      sm: 6,
    },
    ...(service === 'Transit'
      ? [
          {
            name: 'service_type',
            label: 'Service Type *',
            rules: { required: 'Service type is required' },
            options: typeOfAirport,
            placeholder: 'Select Service Type',
            sm: 6,
          },
          {
            name: 'transit_service',
            label: 'Transit Service *',
            rules: { required: 'Transit Service type is required' },
            options: transitServiceType || [],
            placeholder: 'Transit Service Type',
            sm: 12,
          },
        ]
      : [
          {
            name: 'service_type',
            label: 'Service Type *',
            rules: { required: 'Service type is required' },
            options: typeOfAirport,
            placeholder: 'Select Service Type',
            sm: 6,
          },
        ]),
  ];
  const arrivalField = [
    {
      name: 'arrival_airline',
      label: 'Arrival Airline *',
      placeholder: '',
      rules: { required: 'Arrival Airline is required' },
      type: 'text',
      sm: 6,
    },
    {
      name: 'arrival_flight_number',
      label: 'Arrival Flight Number *',
      placeholder: '',
      rules: { required: 'Flight Number is required' },
      type: 'text',
      sm: 6,
    },
    {
      name: 'arrival_date',
      label: 'Arrival Date *',
      placeholder: '',
      type: 'datebooking',

      sm: 6,
      rules: {
        required: 'Date of Arrival is required',
        validate: (value) => {
          if (!value) return 'Date is required';

          const selectedDate = new Date(value).setHours(0, 0, 0, 0);
          const today = new Date().setHours(0, 0, 0, 0);
          const minAllowedDate = new Date();
          minAllowedDate.setHours(minAllowedDate.getHours() + 48); // 48 hours from now

          return selectedDate >= today || 'Date cannot be in the past';
        },
      },
    },
    {
      name: 'arrival_time',
      label: 'Arrival Time *',
      placeholder: '',
      type: 'time',
      sm: 6,
      rules: {
        required: 'Time of Arrival is required',
        validate: (_, formValues) => {
          const { arrival_date, arrival_time } = formValues;

          if (!arrival_date || !arrival_time)
            return 'Date and Time are required';

          const selectedDateTime = new Date(`${arrival_date}T${arrival_time}`);
          const minAllowedDateTime = new Date();

          minAllowedDateTime.setHours(minAllowedDateTime.getHours() + 48); // 48 hours from now
          const pastTimeCheck = new Date();
          return isIntantBooking
            ? selectedDateTime >= pastTimeCheck || 'Future Time Must Select'
            : selectedDateTime >= minAllowedDateTime ||
                'Departure must be at least 48 hours from now';
        },
      },
    },
    {
      name: 'arrival_plan',
      label: 'Service Plan *',
      rules: { required: 'Plan is required' },
      options: services,
      placeholder: 'Select Service Plan',
      sm: 12,
    },
  ];
  const departureField = [
    {
      name: 'departure_airline',
      label: 'Departure Airline *',
      placeholder: '',
      rules: { required: 'Departure Airline is required' },
      type: 'text',
      sm: 6,
    },
    {
      name: 'departure_flight_number',
      label: 'Departure Flight Number *',
      placeholder: '',
      rules: { required: 'Flight Number is required' },
      type: 'text',
      sm: 6,
    },
    {
      name: 'departure_date',
      label: 'Departure Date *',
      placeholder: '',

      type: 'datebooking',
      sm: 6,

      rules: {
        required: 'Date of Departure is required',
        validate: (value) => {
          if (!value) return 'Date is required';
          const selectedDate = new Date(value).setHours(0, 0, 0, 0);
          const today = new Date().setHours(0, 0, 0, 0);
          return selectedDate >= today || 'Date cannot be in the past';
        },
      },
    },
    {
      name: 'departure_time',
      label: 'Departure Time *',
      placeholder: '',
      rules: {
        required: 'Time of Departure is required',

        validate: (_, formValues) => {
          const { departure_date, departure_time } = formValues;

          if (!departure_date || !departure_time)
            return 'Date and Time are required';

          const selectedDateTime = new Date(
            `${departure_date}T${departure_time}`
          );
          const minAllowedDateTime = new Date();
          const pastTimeCheck = new Date();
          minAllowedDateTime.setHours(minAllowedDateTime.getHours() + 48); // 48 hours from now

          return isIntantBooking
            ? selectedDateTime >= pastTimeCheck || 'Future Time Must Select'
            : selectedDateTime >= minAllowedDateTime ||
                'Departure must be at least 48 hours from now';
        },
      },
      type: 'time',
      sm: 6,
    },
    {
      name: 'departure_plan',
      label: 'Service Plan *',
      rules: { required: 'plan is required' },
      options: services,
      placeholder: 'Select Service Plan',
      sm: 12,
    },
  ];
  const transitField = [
    {
      name: 'arrival_airline',
      label: 'Arrival Airline *',
      placeholder: '',
      rules: { required: 'Arrival Airline is required' },
      type: 'text',
      sm: 6,
    },
    {
      name: 'departure_airline',
      label: 'Departure Airline *',
      placeholder: '',
      rules: { required: 'Departure Airline is required' },
      type: 'text',
      sm: 6,
    },
    {
      name: 'arrival_city',
      label: 'Arrival City *',
      placeholder: 'Enter Arrival city',
      rules: { required: 'Arrival City is required' },
      type: 'text',
      sm: 6,
    },
    {
      name: 'departure_city',
      label: 'Departure City *',
      placeholder: 'Enter Departure city',
      rules: { required: 'Departure City is required' },
      type: 'text',
      sm: 6,
    },
    {
      name: 'arrival_flight_number',
      label: 'Arrival Flight Number *',
      placeholder: '',
      rules: { required: 'Flight Number is required' },
      type: 'text',
      sm: 6,
    },
    {
      name: 'departure_flight_number',
      label: 'Departure Flight Number *',
      placeholder: '',
      rules: { required: 'Flight Number is required' },
      type: 'text',
      sm: 6,
    },
    {
      name: 'arrival_date',
      label: 'Arrival Date *',
      placeholder: '',

      rules: {
        required: 'Date of Arrival is required',
        validate: (value) => {
          if (!value) return 'Date is required';
          const selectedDate = new Date(value).setHours(0, 0, 0, 0);
          const today = new Date().setHours(0, 0, 0, 0);
          return selectedDate >= today || 'Date cannot be in the past';
        },
      },
      type: 'datebooking',
      sm: 6,
    },
    {
      name: 'departure_date',
      label: 'Departure Date *',
      placeholder: '',

      rules: {
        required: 'Date of Departure is required',
        validate: (value) => {
          if (!value) return 'Date is required';
          const selectedDate = new Date(value).setHours(0, 0, 0, 0);
          const today = new Date().setHours(0, 0, 0, 0);
          return selectedDate >= today || 'Date cannot be in the past';
        },
      },
      type: 'datebooking',
      sm: 6,
    },

    {
      name: 'arrival_time',
      label: 'Arrival Time *',
      placeholder: '',
      type: 'time',
      sm: 6,
      rules: {
        required: 'Time of Arrival is required',
        validate: (_, formValues) => {
          const { arrival_date, arrival_time } = formValues;

          if (!arrival_date || !arrival_time)
            return 'Date and Time are required';

          const selectedDateTime = new Date(`${arrival_date}T${arrival_time}`);
          const minAllowedDateTime = new Date();

          minAllowedDateTime.setHours(minAllowedDateTime.getHours() + 48); // 48 hours from now

          const pastTimeCheck = new Date();
          return isIntantBooking
            ? selectedDateTime >= pastTimeCheck || 'Future Time Must Select'
            : selectedDateTime >= minAllowedDateTime ||
                'Departure must be at least 48 hours from now';
        },
      },
    },

    {
      name: 'departure_time',
      label: 'Departure Time *',
      placeholder: '',
      rules: {
        required: 'Time of Departure is required',
        validate: (_, formValues) => {
          const { departure_date, departure_time } = formValues;

          if (!departure_date || !departure_time)
            return 'Date and Time are required';

          const selectedDateTime = new Date(
            `${departure_date}T${departure_time}`
          );
          const minAllowedDateTime = new Date();

          minAllowedDateTime.setHours(minAllowedDateTime.getHours() + 48); // 48 hours from now

          const pastTimeCheck = new Date();
          return isIntantBooking
            ? selectedDateTime >= pastTimeCheck || 'Future Time Must Select'
            : selectedDateTime >= minAllowedDateTime ||
                'Departure must be at least 48 hours from now';
        },
      },
      type: 'time',
      sm: 6,
    },
    {
      name: 'transit_plan',
      label: 'Transit Plane *',
      rules: { required: 'plan is required' },
      options: transitServices,
      placeholder: 'Select Service Plan',
      sm: 12,
    },
  ];

  return (
    <Box component={Paper} className='add_airport_details_heading'>
      <Typography variant='h5' className='form-heading'>
        Add Booking
      </Typography>
      <Box className='form-margin'>
        <form
          onSubmit={handleSubmit((data) => {
            let passengerDetailsRoute;
            if (user.role === 'Admin' || user.role === 'Staff') {
              passengerDetailsRoute = BOOKING_PASSENGER_DETAILS;
            } else if (user.role === 'Vendor') {
              passengerDetailsRoute = VENDOR_BOOKING_PASSENGER_DETAILS;
            } else if (user.role === 'Customer') {
              passengerDetailsRoute = CUSTOMER_BOOKING_PASSENGER_DETAILS;
            }

            navigate(passengerDetailsRoute, {
              state: {
                form1Value: formValue11,
                form2Value: form2Value,
                form3Value: form3Value,
              },
            });
          })}
        >
          <Grid container spacing={4}>
            {fields.map((field, index) => (
              <Grid item xs={12} sm={field.sm} key={index}>
                <ControlledTextInputField
                  name={field.name}
                  control={control}
                  rules={field.rules}
                  type={field.type}
                  disabled={field.disabled}
                  setValue={setValue}
                  module={'booking'}
                  label={field.label}
                  placeholder={field.placeholder}
                  options={field.options}
                  getOptionLabel={(option) => option.label}
                  error={!!errors[field.name]}
                  helperText={errors[field.name]?.message}
                />
              </Grid>
            ))}

            {((formValue?.arrival_departure_type?.value !== 'Transit' &&
              formValue?.service_type?.value &&
              formValue?.airport?.value &&
              formValue?.arrival_departure_type?.value) ||
              (formValue?.arrival_departure_type?.value === 'Transit' &&
                formValue?.service_type?.value &&
                formValue?.airport?.value &&
                formValue?.transit_service?.value >= 0)) && (
              <Grid item xs={12}>
                <TableContainer component={Paper} className='form-margin'>
                  <Table
                    sx={{ minWidth: 600, border: 'none' }}
                    aria-label='Services Table'
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell scope='col'>Services</TableCell>

                        <TableCell align='center' scope='col'>
                          Arrival
                        </TableCell>
                        <TableCell align='center' scope='col'>
                          Departure
                        </TableCell>
                        <TableCell align='center' scope='col'>
                          Price
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {tableContent?.length > 0 &&
                      tableContent[0]?.service !== undefined ? (
                        tableContent.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell sx={{ width: '200px' }}>
                              {row.service}
                              {/* - {row.type_of_service} */}
                            </TableCell>

                            <TableCell align='center' sx={{ width: '500px' }}>
                              {row.arrival}
                            </TableCell>
                            <TableCell align='center' sx={{ width: '500px' }}>
                              {row.departure}
                            </TableCell>
                            <TableCell align='center'>{row.price}.00</TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={4} align='center'>
                            No Service Available For This Airport
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}
            {/*Notes for Transit  */}
            {service === 'Transit' && formValue?.transit_service?.value ? (
              <Grid item xs={12} sx={{}}>
                <Typography
                  component={Paper}
                  sx={{
                    textAlign: 'center',
                    backgroundColor: '#f5f5f5',
                    padding: '20px',
                  }}
                  className='typography-message'
                >
                  <StarSymbol>Note: </StarSymbol>
                  "Transit service is available only if the time between the two
                  flights is 6 hours or less. For longer layovers, please book
                  two separate services."
                </Typography>
              </Grid>
            ) : (
              ''
            )}

            {(service === 'Arrival' || service === 'Departure') &&
              formValue?.service_type !== '' &&
              formValue?.airport?.value &&
              (service === 'Arrival' ? arrivalField : departureField).map(
                (field, index) => (
                  <Grid item xs={12} sm={field.sm} key={index}>
                    <ControlledTextInputField
                      name={field.name}
                      control={control}
                      rules={field.rules}
                      type={field.type}
                      instantBooking={field.instantBooking}
                      label={field.label}
                      planeAvailable={tableContent > 0}
                      placeholder={field.placeholder}
                      options={field.options}
                      getOptionLabel={(option) => option.label || ''}
                      error={!!errors[field.name]}
                      helperText={errors[field.name]?.message}
                    />
                  </Grid>
                )
              )}

            {service === 'Transit' &&
              formValue?.transit_service !== '' &&
              formValue?.transit_service?.value >= 0 &&
              transitField.map((field, index) => (
                <Grid item xs={12} sm={field.sm} key={index}>
                  <ControlledTextInputField
                    name={field.name}
                    control={control}
                    rules={field.rules}
                    type={field.type}
                    instantBooking={field.instantBooking}
                    planeAvailable={tableContent > 0}
                    label={field.label}
                    placeholder={field.placeholder}
                    options={field.options}
                    getOptionLabel={(option) => option.label || ''}
                    error={!!errors[field.name]}
                    helperText={errors[field.name]?.message}
                  />
                </Grid>
              ))}
            {/* Submit button */}
            <Grid item xs={12} className='button-container'>
              <CustomButton
                variant='contained'
                className='grey-button'
                text='Back'
                onClick={() => {
                  let bookingsRoute;

                  if (user?.role === 'Admin' || user?.role === 'Staff') {
                    bookingsRoute = BOOKINGS;
                  } else if (user?.role === 'Vendor') {
                    bookingsRoute = VENDOR_BOOKINGS;
                  } else if (user?.role === 'Customer') {
                    bookingsRoute = CUSTOMER_BOOKINGS;
                  }

                  navigate(bookingsRoute);
                }}
              />
              <CustomButton
                variant='contained'
                className='orange-button'
                text='Next'
                type='submit'
              />
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>
  );
};
export default AirPortDetails;
